module.exports = __webpack_public_path__ + "static/media/know-more.36f602e3.png";